<section style="width: 100%; overflow-x: hidden">
  <div class="d-flex justify-content-center align-items-center icon-header">
    <mat-icon [color]="isDefault() ? 'primary' : 'warn'">
      {{isDefault() ? 'info' : 'warning'}}
    </mat-icon>
  </div>
  <h1 mat-dialog-title class="text-center">
    {{title}}
  </h1>
  <div mat-dialog-content>
    @for (message of messages; track message) {
      <p class="m-y-0" [innerHTML]="message"></p>
    }
  </div>
  <div mat-dialog-actions class="d-flex justify-content-center">
    @if (cancel) {
      <button mat-stroked-button color="warn" class="error-button"
      (click)="cancelAction()">{{cancel}}</button>
    }
    @if (confirm) {
      <button mat-raised-button color="primary" (click)="confirmAction()"
      cdkFocusInitial>{{confirm}}</button>
    }
  </div>
</section>